/**
 * ReceivablesPage — Tab wrapper para Cuentas por Cobrar con ayuda contextual.
 */
import { Outlet, useLocation } from 'react-router-dom'
import { PageHeader } from '@/components/HelpPanel'
import { HELP } from '@/data/helpContent'

const PAGE_META: Record<string, { title: string; subtitle: string; helpKey: string }> = {
  collections: { title: 'Cobranza', subtitle: 'Pagos de clientes, gestiones y seguimiento de cobros.', helpKey: 'receivables.collections' },
  aging:       { title: 'Antigüedad de Saldos', subtitle: 'Análisis de deuda por cliente agrupada por días de mora.', helpKey: 'receivables.aging' },
  statements:  { title: 'Estados de Cuenta', subtitle: 'Detalle de facturas y pagos por cliente.', helpKey: 'receivables.statements' },
  reminders:   { title: 'Recordatorios', subtitle: 'Historial de recordatorios de cobranza enviados.', helpKey: 'receivables.reminders' },
  credits:     { title: 'Créditos pendientes', subtitle: 'Saldos a favor de clientes, por notas de crédito sobre facturas pagadas o por cobros en exceso. Se devuelven o se aplican a otra factura.', helpKey: 'receivables.credits' },
  'cash-flow': { title: 'Flujo Proyectado', subtitle: 'Ingresos esperados por semana según vencimientos.', helpKey: 'receivables.cash-flow' },
  'collection-config': { title: 'Configuración de Cobranza', subtitle: 'Días de mora, adjuntos y templates de email personalizables.', helpKey: 'receivables.collection-config' },
}

export default function ReceivablesPage() {
  const { pathname } = useLocation()
  const segment = pathname.split('/').pop() || 'collections'
  const meta = PAGE_META[segment] || PAGE_META.collections

  return (
    <div className="p-4 sm:p-6 max-w-7xl mx-auto">
      <PageHeader title={meta.title} subtitle={meta.subtitle} help={HELP[meta.helpKey]} />
      <Outlet />
    </div>
  )
}
